<template>
  <div>
    <ul class="search">
      <li :class="{ active: cartype == 1 }" @click="searchCar('1')">公车</li>
      <li :class="{ active: cartype == 2 }" @click="searchCar('2')">私车</li>
    </ul>
    <div style="height: 50vh; overflow-y: auto; margin-bottom: 80px">
      <div
        v-for="item in list"
        style="border-bottom: 1px solid #eee; padding-bottom: 5px"
      >
        <el-row
          type="flex"
          align="middle"
          justify="space-between"
          style="height: 45px; width: 100%; font-size: 15px"
        >
          <el-checkbox
            v-model="item.ischecked"
            @change="onChecked($event, item)"
            >{{ item.carno }} {{ item.brand }} {{ item.zuoweishu }}</el-checkbox
          >
          <span
            class="bot"
            :style="{
              backgroundColor: item.stock_state == 1 ? '#1dbd1d' : '#e44d4d',
            }"
          ></span>
        </el-row>
        <div style="font-size: 13px">
          <el-row
            type="flex"
            align="middle"
            justify="space-between"
            v-for="subitem in item.subtask"
            ><span>{{ subitem.gotime }}</span>
            <span>{{ subitem.user_count }}人</span>
            <span
              >{{ subitem.province }}{{ subitem.city }}{{ subitem.area }}</span
            ></el-row
          >
        </div>
      </div>
    </div>
    <div
      style="
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        bottom: 10px; ;
      "
    >
      <el-button type="primary" @click="setCar">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "sel_staff",
  components: {},
  data() {
    return {
      selmode: 1, //1单选2多选
      cartype: "",
      catelist: [],
      list: [],
      checklist: [],
    };
  },
  methods: {
    async searchCar(type) {
      this.cartype = type;

      this.showInfo();
    },
    async showInfo(mode) {
      this.selmode = mode;
      this.list = await this.$api.request.get("/car/get_select_list", {
        params: {
          cartype: this.cartype,
        },
      });
    },
    setCar() {
      if (this.checklist.length == 0) {
        return;
      }
      this.$emit("carSelected", this.checklist);
    },
    onChecked(e, item) {
      if (this.selmode == 1 && e) {
        this.checklist = [];
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].id != item.id) this.list[i].ischecked = false;
        }

        this.checklist.push(item);
      } else {
        if (e) {
          this.checklist.push(item);
        } else {
          for (var i = 0; i < this.checklist.length; i++) {
            if (this.checklist[i].id == item.id) {
              this.checklist.splice(i, 1);
              break;
            }
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.bot {
  float: right;
  display: inline-block;
  border-radius: 50%;
  width: 15px;
  height: 15px;
}
.search {
  display: flex;
  justify-content: space-evenly;
  margin: 0;
  margin-bottom: 15px;
}
.search li {
  text-decoration: none;
  list-style: none;
  width: 30%;
  border: 1px solid #eee;
  text-align: center;
  line-height: 30px;
}
.search .active {
  background: #eee;
}
</style>
